import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Layout from 'components/common/Layout';
import Button from 'components/common/Button';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const styles = () => ({
  section: {
    position: 'relative',
    maxWidth: 800,
    height: '80vh',
    padding: '0 16px',
    margin: '24px auto 0',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  buttonContainer: {
    display: 'inline-flex',
    flexDirection: 'column',
  },
  typographyCounter: {
    marginTop: 16,
  },
});

class PaymentSuccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      autoRedirectCountdown: 100,
    };

    this.onStartAutoRedirectCountdown = this.onStartAutoRedirectCountdown.bind(this);
  }

  componentDidMount() {
    this.onStartAutoRedirectCountdown();
  }

  onStartAutoRedirectCountdown() {
    const { history } = this.props;
    this.autoRedirectCountdownInterval = setInterval(() => {
      const { autoRedirectCountdown } = this.state;
      if (autoRedirectCountdown === 1) {
        history.replace('/settings/payment/dashboard');
        clearInterval(this.autoRedirectCountdownInterval);
      } else {
        this.setState({ autoRedirectCountdown: autoRedirectCountdown - 1 });
      }
    }, 50);
  }

  render() {
    const { theme, classes } = this.props;
    const { autoRedirectCountdown } = this.state;
    
    return (
      <Layout variant="error">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Payment Successful
          </title>
        </Helmet>
        <div className={classes.section}>
          <Grid
            direction="column"
            container
            spacing={24}
            align="center"
            justify="center"
          >
            <Grid item>
              <Typography align="center" variant="title" gutterBottom>
                Payment Successful!
              </Typography>
            </Grid>
            <Grid item>
              <div className={classes.buttonContainer}>
                <Button
                  style={{
                    background: `linear-gradient(
                      to left,
                      ${theme.palette.primary[500]} 0%,
                      ${theme.palette.primary[500]} ${autoRedirectCountdown}%,
                      ${theme.palette.primary[700]} ${autoRedirectCountdown}%,
                      ${theme.palette.primary[700]} 100%)`,
                  }}
                  href="/settings/payment/dashboard"
                  variant="raised"
                  color="primary"
                >
                  Go to Payment Dashboard
                </Button>
                <Typography className={classes.typographyCounter} variant="caption" align="right">
                  in <b>{Math.ceil(autoRedirectCountdown/20)}</b> sec
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      </Layout>
    );
  }
}

PaymentSuccess.propTypes = {
  classes: PropTypes.shape({
    section: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles, { withTheme: true })(PaymentSuccess);



// WEBPACK FOOTER //
// ./src/pages/settings/PaymentSuccess.js